import React, { Component } from 'react';
import {connect} from 'react-redux';
import {actions, RootState, selectors} from '../store';
import Map from '../components/Map';
import MapFilter from '../components/MapFilter';
import {
  withIonLifeCycle, IonPage, IonHeader, IonToolbar, IonButtons, IonButton,
  IonMenuButton, IonTitle, IonContent, IonIcon, IonModal,
} from '@ionic/react';
import { options as optionsIcon } from 'ionicons/icons';
import {Location} from '../store/locations/types';
import {Plugins} from '@capacitor/core';
import { Token } from '../store/users/types';

type Props = typeof mapDispatchToProps & ReturnType<typeof mapStateToProps>;
const {Geolocation} = Plugins;
type State = {
  refocus: boolean;
  showFilterModal: boolean;
  selectedFilter: string [];
}
class MapPage extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      refocus: true,
      showFilterModal: false,
      selectedFilter: ['all']
    };
    this.getMyPosition();
  }

  async ionViewDidEnter() {
    const { refreshAllList, tokens } = this.props;
    if (refreshAllList !== '') {
      this.props.getAllList(tokens, 'visited');
      this.props.getAllList(tokens, 'favorites');
      this.props.getAllList(tokens, 'bucket');
    }
  }

  componentDidMount = async () => {
    // @ts-ignore
    this.props.getAllList(null, 'visited');
    // @ts-ignore
    this.props.getAllList(null, 'favorites');
    // @ts-ignore
    this.props.getAllList(null, 'bucket');
  }
  getMyPosition() {
    if (this.props.userLocationRetrieved) {
      return;
    }
    if (Geolocation) {
      // this.props.getParks();
      // Geolocation.getCurrentPosition().then(coordinates => {
      //   console.log('asdfasdfasdf')
      //   props.addLocation({
      //     id: 0,
      //     name: 'Your current location',
      //     lat: coordinates.coords.latitude,
      //     lng: coordinates.coords.longitude
      //   });
      // });
    } else {
      console.log('gettting parks')
      // props.getParks();
    }
  }
  presentFilter = () => {
    this.setState(() => ({
      showFilterModal: true
    }));
  };

  dismissFilter = () => {
    this.setState(() => ({
      showFilterModal: false
    }));
  };

  updateFilter = (data: any, refocus: boolean) => {
    this.setState({
      ...this.state,
      selectedFilter: data,
      refocus,
    });
  };

  setRefresh = (refresh: false) => {

  }
  render() {
    return (
      <IonPage>
        <IonHeader>
        <IonToolbar color="primary">
            <IonButtons slot="start">
              <IonMenuButton />
            </IonButtons>
            <IonTitle>National Parks Map</IonTitle>

            <IonButtons slot="end">
              <IonButton onClick={this.presentFilter}>
                <IonIcon icon={optionsIcon} slot="icon-only" />
              </IonButton>
            </IonButtons>
          </IonToolbar>
        </IonHeader>

        <IonContent class="map-page">
          <Map
            refocus={this.state.refocus}
            refresh={this.props.refreshAllList}
            setRefresh={() => this.setRefresh(false)}
            isLoggedIn={this.props.isLoggedIn}
            formattedUsersList={this.props.formattedUsersList}
            filter={this.state.selectedFilter}
            locations={this.props.locations}
            mapCenter={this.props.mapCenter}
            />
        </IonContent>
        <IonModal
          isOpen={this.state.showFilterModal}
          onDidDismiss={this.dismissFilter}
        >
          <MapFilter
            refocus={this.state.refocus}
            selectedFilters={this.state.selectedFilter}
            updateFilter={this.updateFilter}
            dismissModal={this.dismissFilter}
          />
        </IonModal>
      </IonPage>
    );
  }
}

const mapDispatchToProps = {
  refreshTokens: (refresh_token: string) => actions.users.refreshTokens(refresh_token),
  setTokens: (tokens: Token) => actions.users.setTokens(tokens),
  getAllList: (tokens: Token, type: string) => actions.users.getAllList(tokens, type),
  addLocation: (location: Location) => actions.locations.updateLocations(location),
  // getParks: () => actions.locations.getParks(),
  setRefresh: (refresh: boolean) => actions.users.setRefresh(refresh),
};

const mapStateToProps = (state: RootState) => ({
  refresh: state.locations.refresh,
  refreshAllList: state.users.refreshAllList,
  tokens: state.users.tokens,
  isLoggedIn: state.users.loggedIn,
  formattedUsersList: selectors.locations.formatUsersList(state.users.visitedList, state.users.favoritesList, state.users.bucketList),
  locations: selectors.locations.onlyWithLocations(state.places.places),
  // locations: selectors.locations.allLocations(state.locations),
  mapCenter: selectors.locations.mapCenter(state.locations),
  userLocationRetrieved: state.locations.userLocationRetrieved,
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withIonLifeCycle(MapPage));
